import clsx from 'clsx'
import type { ReactNode } from 'react'
import type { ExportMenuDot } from '../logic/exportStatus'

/**
 * An Export menu's dot (docs/specs/EXPORTS.md, The Export menu): amber while
 * an export in its scope runs, blue once one is ready and not yet seen. It
 * sits on the top-right corner of whatever positions it.
 */
export function ExportDot({ dot }: { dot: ExportMenuDot }) {
  if (!dot) return null
  return (
    <span
      data-export-dot={dot}
      aria-hidden="true"
      className={clsx(
        'pointer-events-none absolute -right-1 -top-1 h-2 w-2 rounded-full',
        dot === 'running' ? 'bg-[color:var(--border-warning)]' : 'bg-[color:var(--accent-info)]'
      )}
    />
  )
}

/** An icon-only menu button's icon with its dot on the icon's corner. */
export default function ExportMenuIcon({ icon, dot }: { icon: ReactNode; dot: ExportMenuDot }) {
  return (
    <span className="relative inline-flex">
      {icon}
      <ExportDot dot={dot} />
    </span>
  )
}
